import { render, staticRenderFns } from "./user_popover.vue.js?vue&type=template&id=753c1ea2!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_popover.vue?vue&type=template&id=753c1ea2"
import script from "./user_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_popover.vue?vue&type=script&lang=js"
export * from "./user_popover.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./user_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports